/**
 * HTTP layer for persistent ethernet connections. The inbound ethernet links
 * from client networks: list active connections and force-drop one.
 *
 * Contains:
 * - fetchEthernetConnections: list active ethernet connections
 * - killEthernetConnection: force-drop one connection
 */
import apiClient from '@sophocles/http-common';

export const fetchEthernetConnections = (params = {}) =>
  apiClient.get('ethernet-connections/', { params }).then(res => res.data);

export const killEthernetConnection = identifier =>
  apiClient.post(`ethernet-connections/${identifier}/kill/`).then(res => res.data);
